"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createProperty = createProperty;
exports.normalizePropertyGroups = normalizePropertyGroups;
exports.normalizePropertyGroupsImmutable = normalizePropertyGroupsImmutable;
exports.normalizeBidenGroups = normalizeBidenGroups;
exports.normalizeVisitGroups = normalizeVisitGroups;
exports.addAssociatedCompanyProperty = addAssociatedCompanyProperty;
exports.addAssociatedContactProperty = addAssociatedContactProperty;
exports.addDealStageProbability = addDealStageProbability;
exports.addFormSubmissionProperty = addFormSubmissionProperty;
exports.addInboundDbImportProperty = addInboundDbImportProperty;
exports.addListMembershipProperty = addListMembershipProperty;
exports.unhideTicketPipelineProperties = unhideTicketPipelineProperties;
exports.fetchPropertyGroups = fetchPropertyGroups;
exports.fetchPropertyGroupsBatch = fetchPropertyGroupsBatch;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _AssociatedCompanyProperty = _interopRequireDefault(require("customer-data-objects/property/special/AssociatedCompanyProperty"));

var _AssociatedContactProperty = _interopRequireDefault(require("customer-data-objects/property/special/AssociatedContactProperty"));

var _EngagementProperties = _interopRequireDefault(require("customer-data-objects/engagement/EngagementProperties"));

var _FormSubmissionsProperty = _interopRequireDefault(require("customer-data-objects/property/special/FormSubmissionsProperty"));

var _InboundDbImportProperty = _interopRequireDefault(require("customer-data-objects/property/special/InboundDbImportProperty"));

var _ListMembershipsProperty = _interopRequireDefault(require("customer-data-objects/property/special/ListMembershipsProperty"));

var _filterNot = _interopRequireDefault(require("transmute/filterNot"));

var _getIn = _interopRequireDefault(require("transmute/getIn"));

var _immutable = require("immutable");

var _ImmutableAPI = require("../api/ImmutableAPI");

var _indexBy = _interopRequireDefault(require("transmute/indexBy"));

var _partial = _interopRequireDefault(require("transmute/partial"));

var _pluck = _interopRequireDefault(require("transmute/pluck"));

var _invariant = _interopRequireDefault(require("react-utils/invariant"));

var _ObjectTypes = require("customer-data-objects/constants/ObjectTypes");

var _pick = _interopRequireDefault(require("transmute/pick"));

var _pipe = _interopRequireDefault(require("transmute/pipe"));

var _PropertyGroupRecord = _interopRequireDefault(require("customer-data-objects/property/PropertyGroupRecord"));

var _PropertyRecord = _interopRequireDefault(require("customer-data-objects/property/PropertyRecord"));

var _q = _interopRequireDefault(require("q"));

var _toSeq = _interopRequireDefault(require("transmute/toSeq"));

var _MetaAPI = require("crm_data/meta/MetaAPI");

var _DealStageProbabilityProperty = _interopRequireDefault(require("customer-data-objects/property/special/DealStageProbabilityProperty"));

var _CreateApis, _GroupApis;

var CreateApis = (_CreateApis = {}, (0, _defineProperty2.default)(_CreateApis, _ObjectTypes.COMPANY, 'properties/v2/company/properties'), (0, _defineProperty2.default)(_CreateApis, _ObjectTypes.CONTACT, 'properties/v2/contact/properties'), (0, _defineProperty2.default)(_CreateApis, _ObjectTypes.DEAL, 'properties/v2/deal/properties'), (0, _defineProperty2.default)(_CreateApis, _ObjectTypes.TICKET, 'properties/v2/ticket/properties'), _CreateApis);

function getCreateApi(objectType) {
  (0, _invariant.default)(Object.prototype.hasOwnProperty.call(CreateApis, objectType), 'no API is defined for objectType `%s`', objectType);
  return CreateApis[objectType];
}

var pickSavableFields = (0, _pick.default)(_PropertyRecord.default.savableFields);

function createProperty(objectType, newProperty) {
  (0, _invariant.default)(newProperty instanceof _PropertyRecord.default, 'expected a `PropertyRecord` but got `%s`', newProperty);
  return (0, _ImmutableAPI.post)(getCreateApi(objectType), pickSavableFields(newProperty), _PropertyRecord.default.fromJS);
}

var GroupApis = (_GroupApis = {}, (0, _defineProperty2.default)(_GroupApis, _ObjectTypes.COMPANY, 'properties/v2/company/groups'), (0, _defineProperty2.default)(_GroupApis, _ObjectTypes.CONTACT, 'properties/v2/contact/groups'), (0, _defineProperty2.default)(_GroupApis, _ObjectTypes.DEAL, 'properties/v2/deal/groups'), (0, _defineProperty2.default)(_GroupApis, _ObjectTypes.TICKET, 'properties/v2/ticket/groups'), (0, _defineProperty2.default)(_GroupApis, _ObjectTypes.PRODUCT, 'properties/v2/product/groups'), (0, _defineProperty2.default)(_GroupApis, _ObjectTypes.LINE_ITEM, 'properties/v2/line_item/groups'), _GroupApis);

function getGroupsApi(objectType) {
  (0, _invariant.default)(Object.prototype.hasOwnProperty.call(GroupApis, objectType), 'no API is defined for objectType `%s`', objectType);
  return GroupApis[objectType];
}

function normalizePropertyGroups(json) {
  return (0, _immutable.Map)({
    groups: json.reduce(function (groupsMap, group) {
      var propertyNames = group.properties.map(function (property) {
        return property.name;
      });
      return groupsMap.set(group.name, _PropertyGroupRecord.default.fromJS((0, _extends2.default)({}, group, {
        properties: propertyNames
      })));
    }, (0, _immutable.Map)()),
    properties: json.reduce(function (allProperties, group) {
      var properties = group.properties || (0, _immutable.List)();
      return properties.reduce(function (acc, property) {
        return acc.set(property.name, _PropertyRecord.default.fromJS(property));
      }, allProperties);
    }, (0, _immutable.Map)())
  });
}

function normalizePropertyGroupsImmutable(json) {
  if (!json.toJS) {
    return normalizePropertyGroups(json);
  }

  return (0, _immutable.Map)({
    groups: json.reduce(function (groupsMap, group) {
      return groupsMap.set(group.get('name'), _PropertyGroupRecord.default.fromJS(group.set('properties', (0, _pluck.default)('name', group.get('properties'))).toJS()));
    }, (0, _immutable.Map)()),
    properties: json.reduce(function (allProperties, group) {
      var properties = group.get('properties') || (0, _immutable.List)();
      return properties.reduce(function (acc, property) {
        return acc.set(property.get('name'), _PropertyRecord.default.fromJS(property.toJS()));
      }, allProperties);
    }, (0, _immutable.Map)())
  });
}

var hiddenVisitProperties = _immutable.Set.of('address1', 'address2', 'dnsresolves', 'email', 'latitude', 'longitude', 'numcontacts', 'organization');

var dropHiddenProperties = (0, _pipe.default)(_toSeq.default, (0, _filterNot.default)(function (_ref) {
  var name = _ref.name;
  return hiddenVisitProperties.contains(name);
}), (0, _indexBy.default)((0, _getIn.default)(['name'])));
var PROSPECTS_GROUP = 'prospects';

function normalizeBidenGroups(json) {
  var visibleItems = dropHiddenProperties(json);
  return (0, _immutable.Map)({
    groups: (0, _immutable.Map)((0, _defineProperty2.default)({}, PROSPECTS_GROUP, (0, _PropertyGroupRecord.default)({
      displayName: 'Prospect properties',
      displayOrder: 0,
      name: PROSPECTS_GROUP,
      properties: visibleItems.keySeq().toList()
    }))),
    properties: visibleItems.map(function (item) {
      return _PropertyRecord.default.fromJS((0, _extends2.default)({}, item, {
        groupName: PROSPECTS_GROUP,
        isBidenProperty: true,
        readOnlyValue: true
      }));
    }).toMap()
  });
}

var VISITS_GROUP = 'companyVisits';

function normalizeVisitGroups(json) {
  var visibleItems = dropHiddenProperties(json);
  return (0, _immutable.Map)({
    groups: (0, _immutable.Map)((0, _defineProperty2.default)({}, VISITS_GROUP, (0, _PropertyGroupRecord.default)({
      displayName: 'Visit properties',
      displayOrder: 1,
      name: VISITS_GROUP,
      properties: visibleItems.keySeq().toList()
    }))),
    properties: visibleItems.map(function (item) {
      return _PropertyRecord.default.fromJS((0, _extends2.default)({}, item, {
        groupName: VISITS_GROUP,
        isBidenProperty: true,
        readOnlyValue: true
      }));
    }).toMap()
  });
}

function addAssociatedCompanyProperty(result) {
  if (!result.hasIn(['groups', 'dealinformation'])) {
    return result;
  }

  var groupPath = ['groups', 'dealinformation', 'properties'];
  return result.setIn(groupPath, result.getIn(groupPath).push(_AssociatedCompanyProperty.default.name)).setIn(['properties', _AssociatedCompanyProperty.default.name], _AssociatedCompanyProperty.default);
}

function addAssociatedContactProperty(result) {
  if (!result.hasIn(['groups', 'dealinformation'])) {
    return result;
  }

  var groupPath = ['groups', 'dealinformation', 'properties'];
  return result.setIn(groupPath, result.getIn(groupPath).push(_AssociatedContactProperty.default.name)).setIn(['properties', _AssociatedContactProperty.default.name], _AssociatedContactProperty.default);
}

function addDealStageProbability(result) {
  if (!result.hasIn(['groups', 'dealinformation'])) {
    return result;
  }

  var groupPath = ['groups', 'dealinformation', 'properties'];
  return result.setIn(groupPath, result.getIn(groupPath).push(_DealStageProbabilityProperty.default.name)).setIn(['properties', _DealStageProbabilityProperty.default.name], _DealStageProbabilityProperty.default);
}

function addFormSubmissionProperty(result) {
  if (!result.hasIn(['groups', 'contactinformation'])) {
    return _q.default.Promise.resolve(result);
  }

  var groupPath = ['groups', 'contactinformation', 'properties'];
  return _q.default.Promise.resolve(result.setIn(groupPath, result.getIn(groupPath).push(_FormSubmissionsProperty.default.name)).setIn(['properties', _FormSubmissionsProperty.default.name], _FormSubmissionsProperty.default));
}

function addInboundDbImportProperty() {
  var groupname = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'contactinformation';
  var result = arguments.length > 1 ? arguments[1] : undefined;

  if (!result.hasIn(['groups', groupname])) {
    return _q.default.Promise.resolve(result);
  }

  var groupPath = ['groups', groupname, 'properties'];
  return _q.default.Promise.resolve(result.setIn(groupPath, result.getIn(groupPath).push(_InboundDbImportProperty.default.name)).setIn(['properties', _InboundDbImportProperty.default.name], _InboundDbImportProperty.default));
}

function addListMembershipProperty(result) {
  if (!result.hasIn(['groups', 'contactinformation'])) {
    return _q.default.Promise.resolve(result);
  }

  var groupPath = ['groups', 'contactinformation', 'properties'];
  return _q.default.Promise.resolve(result.setIn(groupPath, result.getIn(groupPath).push(_ListMembershipsProperty.default.name)).setIn(['properties', _ListMembershipsProperty.default.name], _ListMembershipsProperty.default));
}

function unhideTicketPipelineProperties(result) {
  if (!result.hasIn(['groups', 'ticketinformation'])) {
    return _q.default.Promise.resolve(result);
  }

  var pipelineProperty = result.getIn(['properties', 'hs_pipeline']).set('hidden', false);
  var pipelineStageProperty = result.getIn(['properties', 'hs_pipeline_stage']).set('hidden', false);
  return _q.default.Promise.resolve(result.setIn(['properties', 'hs_pipeline'], pipelineProperty).setIn(['properties', 'hs_pipeline_stage'], pipelineStageProperty));
}

function fetchPropertyGroups(_ref2) {
  var objectType = _ref2.objectType;

  // Engagement/Task properties only exist on the front end
  if (objectType === _ObjectTypes.ENGAGEMENT || objectType === _ObjectTypes.TASK) {
    return _q.default.Promise.resolve(_EngagementProperties.default);
  } // Visit properties live at two different APIs


  if (objectType === _ObjectTypes.VISIT) {
    return _q.default.Promise.all([(0, _ImmutableAPI.get)('biden/v1/properties', {}, normalizeBidenGroups), (0, _ImmutableAPI.get)('companyprospects/v1/prospects/search/properties', {}, normalizeVisitGroups)]).then(function (_ref3) {
      var _ref4 = (0, _slicedToArray2.default)(_ref3, 2),
          bidenGroup = _ref4[0],
          visitGroup = _ref4[1];

      return bidenGroup.mergeDeep(visitGroup);
    });
  }

  var fallback = function fallback() {
    return (0, _ImmutableAPI.get)(getGroupsApi(objectType), {
      includeProperties: true
    });
  };

  var result = (0, _MetaAPI.queueFetch)("GROUPED_" + objectType + "_PROPERTIES", fallback, {}, normalizePropertyGroupsImmutable);

  if (objectType === _ObjectTypes.COMPANY) {
    return result.then((0, _partial.default)(addInboundDbImportProperty, 'companyinformation'));
  }

  if (objectType === _ObjectTypes.CONTACT) {
    return result.then(addFormSubmissionProperty).then((0, _partial.default)(addInboundDbImportProperty, 'contactinformation')).then(addListMembershipProperty);
  }

  if (objectType === _ObjectTypes.DEAL) {
    return result.then(addAssociatedCompanyProperty).then(addAssociatedContactProperty).then((0, _partial.default)(addInboundDbImportProperty, 'dealinformation')).then(addDealStageProbability);
  }

  if (objectType === _ObjectTypes.TICKET) {
    return result.then(unhideTicketPipelineProperties);
  }

  return result;
}

function fetchPropertyGroupsBatch(objectTypes) {
  return _q.default.Promise.all(objectTypes.map(function (objectType) {
    return fetchPropertyGroups({
      objectType: objectType
    });
  }).toArray()).then(function (results) {
    return results.reduce(function (acc, result, index) {
      return acc.set(objectTypes.get(index), result);
    }, (0, _immutable.Map)());
  });
}